__turbopack_context__.v({
  "avatarSkeleton": "GLYB4W_avatarSkeleton",
  "badgeSkeleton": "GLYB4W_badgeSkeleton",
  "buttonSkeleton": "GLYB4W_buttonSkeleton",
  "card": "GLYB4W_card",
  "cardContent": "GLYB4W_cardContent",
  "dateSkeleton": "GLYB4W_dateSkeleton",
  "descriptionSkeleton": "GLYB4W_descriptionSkeleton",
  "line": "GLYB4W_line",
  "lineShort": "GLYB4W_lineShort",
  "overline": "GLYB4W_overline",
  "shimmer": "GLYB4W_shimmer",
  "titleSkeleton": "GLYB4W_titleSkeleton",
});
